
                    const sheet = new CSSStyleSheet();
                    sheet.replaceSync(":host {\r\n    display: block;\r\n}\r\n");
                    export default sheet;
                